import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import MbTabs from 'components/organisms/MbTabs';
import MainTemplate from 'pages/templates/MainTemplate';
import IpBlock from 'pages/Main/Adver/IpBlock/IpBlock';

import DbPartition from './DbPartition';
import DbSetting from './DbSetting';
import CodeSetting from './CodeSetting';
import ReqSetting from './ReqSetting';
import DbSettingDetail from './DbSettingDetail';

const DevServerInfo = () => {
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  return (
    <MainTemplate>
      <MbTabs
        name="DevServerInfo"
        tabMenuList={tabList()}
        tabs={{
          '/system/server/db_partition': {
            tabComponent: <DbPartition />,
          },
          '/system/server/db_setting': {
            tabComponent: <DbSetting />,
          },
          '/system/server/ip_block': {
            tabComponent: <IpBlock />,
          },
          '/system/server/code_setting': {
            tabComponent: <CodeSetting />,
          },
          '/system/server/req_setting': {
            tabComponent: <ReqSetting />,
          },
          '/system/server/db_detail': {
            tabComponent: <DbSettingDetail />,
            isPop: 1,
          },
        }}
      />
    </MainTemplate>
  );
};

export default DevServerInfo;
